module.exports = __webpack_public_path__ + "img/MES_Background.8f76ea2f.png";